export { default as updateGameText } from "./updateGameText";
